import { Archive, ArrowCounterClockwise, PencilSimple } from '@phosphor-icons/react';

import { Button } from '../ui/Button';

/**
 * `.pen` → `ds/table/row-actions`: par de ícone-botões ghost circulares
 * (editar + arquivar/reactivar) reutilizado em qualquer linha de lista com
 * acções. Passa `onRestore` (em vez de `onArchive`) para linhas já
 * arquivadas — troca o ícone para `arrow-counter-clockwise`.
 */
export function RowActions({
  item,
  onEdit,
  onArchive,
  onRestore,
  editLabel = 'Editar',
  archiveLabel = 'Arquivar',
  restoreLabel = 'Reactivar',
}) {
  return (
    <>
      {onEdit ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-8 w-8 px-0"
          aria-label={editLabel}
          onClick={() => onEdit(item)}
        >
          <PencilSimple className="h-3.5 w-3.5" aria-hidden />
        </Button>
      ) : null}
      {onRestore ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-8 w-8 px-0"
          aria-label={restoreLabel}
          onClick={() => onRestore(item)}
        >
          <ArrowCounterClockwise className="h-3.5 w-3.5" aria-hidden />
        </Button>
      ) : onArchive ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-8 w-8 px-0"
          aria-label={archiveLabel}
          onClick={() => onArchive(item)}
        >
          <Archive className="h-3.5 w-3.5" aria-hidden />
        </Button>
      ) : null}
    </>
  );
}
